<script setup>
  import { ref, onMounted, watch } from 'vue';

  const props = defineProps({
    lat: {
      type: Number,
      default: 27.7676
    },
    lon: {
      type: Number,
      default: -82.6403
    }
  });

  const mapContainer = ref(null);
  const map = ref(null);

  function createMap() {
    if (map.value || !mapContainer.value) return;

    map.value = new google.maps.Map(mapContainer.value, {
      center: { lat: props.lat, lng: props.lon },
      zoom: 12,
      gestureHandling: 'none',
      zoomControl: false,
      disableDefaultUI: true,
      mapTypeId: 'satellite',
    });
  }

  onMounted(() => createMap());

  watch(() => [props.lat, props.lon], ([lat, lon]) => {
    if (map.value) {
      map.value.setCenter({ lat, lng: lon });
    }
  });
</script>

<template>
  <div class="jwx-wind-dir-map">
    <div ref="mapContainer" class="jwx-wind-dir-map__map"></div>
    <div class="jwx-wind-dir-map__overlay"></div>
    <div class="jwx-wind-dir-map__content">
      <slot></slot>
    </div>
  </div>
</template>
